<script lang="ts" setup>
import { IYearMonth } from '@/coreDomainsModule/date';
import { BusinessesForSupplierForecastHeaderKey, TableContentProperty } from '../../interface/tableContentHeaders';
import { TableContentItem } from '../../interface/tableContentItems';
import TableCell from '../TableCell.vue';
import SupplierForecastCreationStatusIcon from './SupplierForecastCreationStatusIcon.vue';
import { BusinessesForSupplierForecastTableContentViewModel } from './businessesForSupplierForecastTableContentViewModel';
import { computed } from 'vue';

// props
const props = withDefaults(
  defineProps<{
    header: TableContentProperty;
    headerKey: BusinessesForSupplierForecastHeaderKey;
    item: TableContentItem;
    headerIndex: number;
    accumulationTableContentWidth: number;
    isVariableWidth: boolean;
    isAllSelected: boolean;
    stableColumnCount: number;
    isBold: boolean;
    forecastStartYearMonth?: IYearMonth;
    isChecked: boolean;
    isCheckedBusinessId: boolean;
  }>(),
  {
    forecastStartYearMonth: undefined,
  }
);

// emits
const emits = defineEmits<{
  (e: 'onClickNarrow'): void;
}>();

const businessesForSupplierForecastTableContentVM = new BusinessesForSupplierForecastTableContentViewModel();

const textAlign = computed(() => {
  return props.header.propertyPath?.propertyType === 'number' ? 'right' : 'left';
});
</script>

<template>
  <TableCell
    :class="[businessesForSupplierForecastTableContentVM.isSticky(stableColumnCount, headerIndex) ? 'sticky-content' : '']"
    :style="{
      left: businessesForSupplierForecastTableContentVM.calcStickyDiff(stableColumnCount, headerIndex, accumulationTableContentWidth),
    }"
    class="table-cell base-table__body--fixed"
    :text-align="textAlign"
    :table-content-property="header"
    :tool-tip-value="businessesForSupplierForecastTableContentVM.displayForecastForReceiptItem(headerKey, item, forecastStartYearMonth)"
    :is-highlighted="props.isChecked || props.isCheckedBusinessId"
  >
    <span class="table-cell-content" :class="{ 'table-cell-content': isBold }" @click="emits('onClickNarrow')">
      {{ businessesForSupplierForecastTableContentVM.displayForecastForReceiptItem(headerKey, item, forecastStartYearMonth) }}
    </span>
  </TableCell>
</template>

<style scoped lang="scss">
.table-cell-content {
  font-family: Noto Sans JP;
  font-size: $fontSizeSS;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &--bold {
    font-weight: bold;
  }
}
</style>
